export const OVERPAYMENT_REASONS_URL = '/settings/overpayment-reasons'
export const OVERPAYMENT_REASON_API = '/api/internal/overpayment-reason'

export const OVERPAYMENT_REASONS_BREADCRUMBS = [
  { title: 'Настройки', path: '/settings' },
  { title: 'Причины переоплат', path: OVERPAYMENT_REASONS_URL },
]
